import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { OrganizationSchema, WebSiteSchema, WebPageSchema, FAQPageSchema, BreadcrumbListSchema } from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import PromotionSection from './components/PromotionSection';
import MembershipSection from './components/MembershipSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="壹号娱乐 - 顶级娱乐体验平台 | 壹号娱乐官网"
        description="壹号娱乐是您值得信赖的综合娱乐平台，提供多元化娱乐内容与极致体验服务。无论您追求刺激游戏、精彩活动还是优质会员权益，壹号娱乐都能满足您的一切娱乐需求，立即加入享受尊享服务。"
        url="https://bukedg.cn/"
      />
      <FAQPageSchema />
      <BreadcrumbListSchema />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <PromotionSection />
        <MembershipSection />
        <ArticleSection />
        <FAQSection />
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}